// document.addEventListener("DOMContentLoaded", function() {
//     function updateCartCount() {
//         fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             document.querySelector('.cart-count').innerText = cart.item_count;
//         })
//         .catch(error => console.error('Cart update error:', error));
//     }

//     document.querySelectorAll('.add-to-cart-form').forEach(function(form) {
//         form.addEventListener('submit', function(event) {
//             event.preventDefault(); // Prevent default form submission
            
//             let formData = new FormData(this);
            
//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Product added:', data);
//                 return fetch('/cart.js'); // Immediately fetch updated cart
//             })
//             .then(response => response.json())
//             .then(cart => {
//                 document.querySelector('.cart-count').innerText = cart.item_count;
//             })
//             .catch(error => console.error('Error:', error));
//         });
//     });

//     // **Force update cart count on page load**
//     setTimeout(updateCartCount, 500);
// });


    // header active
    $(document).ready(function(){
        $('.nav-center li a').click(function(){
            //remove all pre-existing active classes
            $('.nav-center li a.active').removeClass('active');
            $(this).addClass('active');
        });
    });

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
//         form.addEventListener('submit', function (event) {
//             event.preventDefault(); // Prevent default form submission
            
//             let variantId = this.getAttribute('data-id');

//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ id: variantId, quantity: 1 })
//             })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Product added:', data);
//                 location.reload(); // Auto refresh the page after adding to cart
//             })
//             .catch(error => console.error('Error:', error));
//         });
//     });
// });




//   header script

function closeDiv() {
	document.getElementById("Dropdown2").style.display = "none";
}

function openNav() {
	document.getElementById("mySidebar").style.width = "425px";
	document.getElementById("mySidebar").style.transition = "0.5s";
	document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
	document.getElementById("SidebarUl").style.opacity = "1";
	document.getElementById("SidebarUl").style.transition = "0.2s";
}
var abc;

function closeNav() {
	document.getElementById("mySidebar").style.width = "0";
	document.getElementById("mySidebar").style.boxShadow = "none ";
	document.getElementById("SidebarUl").style.opacity = "0 ";
	document.getElementById("SidebarUl").style.transition = "0.1s";
	var sd = document.getElementsByClassName("MobileNav2");
	for (let i = 0; i < sd.length; i++) {
		sd[i].style.width = "0";
		sd[i].style.left = "-100px";
	}

}

function OpenLi(clickedID) {
	var elementid = document.getElementById(clickedID);
	let str = clickedID;
	str = str.substring(1);
	// alert(str);
	// if ("NavItem1" == clickedID) {
	var Imgid = document.getElementById(str);
	Imgid.style.width = "425px";
	Imgid.style.left = "0";
	abc = Imgid;
	// }
}

function backtoNav() {
	var ccc = abc;
	ccc.style.width = "0";
	ccc.style.left = "-100px";

}

// top x
$(document).ready(function(){
	$(".cross-top-bar").click(function(){
	  $(".top-h-breadcrumb").hide();
	});
  });



//  ============  product page slider =============

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    // prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    // nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,

responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
      }
    },
   
    {
      breakpoint: 576,
      settings: {
      slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
      slidesToShow: 3,
      }
    }
    ]
});

// home collection
$('.testimonial-row-1').slick({
	infinite: true,
	slidesToShow: 4,
	prevArrow: '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/0917/9637/3828/files/review-left.svg?v=1740567438" alt="img">',
	nextArrow: '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/0917/9637/3828/files/review-right.svg?v=1740567437" alt="img">',
	slidesToScroll: 1,
	responsive: [
	  {
		breakpoint: 1200,
		settings: {
		  slidesToShow:3
		}
	  },
	  {
		breakpoint: 992,
		settings: {
		  slidesToShow: 2
		}
	  },
		{
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
	  ]
  });


  $('.testimonial-row-2').slick({
	infinite: true,
	slidesToShow: 3,
	dots:true,
	slidesToScroll: 1,
	responsive: [
	  {
		breakpoint: 1200,
		settings: {
		  slidesToShow:2
		}
	  },
	  {
		breakpoint: 992,
		settings: {
		  slidesToShow: 2
		}
	  },
		{
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
	  ]
  });



// video style
// video 1
const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}
circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
	circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
	circlePlayButton.style.opacity = 1;
});


// video 2
const video1 = document.getElementById("video1");
const circlePlayButton1 = document.getElementById("circle-play-b1");

function togglePlay1() {
	if (video1.paused || video1.ended) {
		video1.play();
	} else {
		video1.pause();
	}
}
circlePlayButton1.addEventListener("click", togglePlay1);
video1.addEventListener("playing", function () {
	circlePlayButton1.style.opacity = 0;
});
video1.addEventListener("pause", function () {
	circlePlayButton1.style.opacity = 1;
});


// video 3
const video2 = document.getElementById("video2");
const circlePlayButton2 = document.getElementById("circle-play-b2");

function togglePlay2() {
	if (video2.paused || video2.ended) {
		video2.play();
	} else {
		video2.pause();
	}
}
circlePlayButton2.addEventListener("click", togglePlay2);
video2.addEventListener("playing", function () {
	circlePlayButton2.style.opacity = 0;
});
video2.addEventListener("pause", function () {
	circlePlayButton2.style.opacity = 1;
});

// video 4
const video3 = document.getElementById("video3");
const circlePlayButton3 = document.getElementById("circle-play-b3");

function togglePlay3() {
	if (video3.paused || video3.ended) {
		video3.play();
	} else {
		video3.pause();
	}
}
circlePlayButton3.addEventListener("click", togglePlay3);
video3.addEventListener("playing", function () {
	circlePlayButton3.style.opacity = 0;
});
video3.addEventListener("pause", function () {
	circlePlayButton3.style.opacity = 1;
});




//   filter.js
let index = 1;

const on = (listener, query, fn) => {
	document.querySelectorAll(query).forEach(item => {
		item.addEventListener(listener, el => {
			fn(el);
		})
	})
}

on('click', '.selectBtn', item => {
	const next = item.target.nextElementSibling;
	next.classList.toggle('toggle');
	next.style.zIndex = index++;
});
on('click', '.option', item => {
	item.target.parentElement.classList.remove('toggle');

	const parent = item.target.closest('.select').children[0];
	parent.setAttribute('data-type', item.target.getAttribute('data-type'));
	parent.innerText = item.target.innerText;
})


